module.exports = __webpack_public_path__ + "img/00030.6602fefb.webp";